import React from 'react';
import { DollarSignIcon, CalendarIcon, BarChartIcon, TagIcon, GlobeIcon } from 'lucide-react';
const Monetization = () => {
  return <section className="py-16 bg-white" data-id="element-149">
      <div className="container mx-auto px-4" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl font-bold mb-4" data-id="element-152">Monetization Models</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-153">
            Voxie offers flexible monetization options that telecom operators
            can implement to generate new revenue streams.
          </p>
          <div className="flex items-center justify-center mt-4 text-gray-500" data-id="element-154">
            <GlobeIcon className="h-5 w-5 mr-2" data-id="element-155" />
            <p data-id="element-156">Pricing is adjustable by country to ensure market fit</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-157">
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-158">
            <div className="bg-green-100 p-3 rounded-full inline-block mb-4" data-id="element-159">
              <TagIcon className="h-8 w-8 text-green-600" data-id="element-160" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-161">Free Tier</h3>
            <p className="text-gray-600 mb-4" data-id="element-162">
              Limited usage with cap (e.g., 10 daily messages) to attract users
              and demonstrate value.
            </p>
            <div className="text-green-600 font-bold text-2xl mb-2" data-id="element-163">Free</div>
            <ul className="text-gray-600 space-y-2" data-id="element-164">
              <li className="flex items-start" data-id="element-165">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-166">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-167" />
                </svg>
                <span data-id="element-168">Limited daily messages</span>
              </li>
              <li className="flex items-start" data-id="element-169">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-170">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-171" />
                </svg>
                <span data-id="element-172">Basic AI capabilities</span>
              </li>
              <li className="flex items-start" data-id="element-173">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-174">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-175" />
                </svg>
                <span data-id="element-176">Sponsored recommendations</span>
              </li>
            </ul>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-177">
            <div className="bg-blue-100 p-3 rounded-full inline-block mb-4" data-id="element-178">
              <BarChartIcon className="h-8 w-8 text-blue-600" data-id="element-179" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-180">Pay-Per-Use</h3>
            <p className="text-gray-600 mb-4" data-id="element-181">
              Charge users for each additional interaction beyond the free tier
              limit.
            </p>
            <div className="text-blue-600 font-bold text-2xl mb-2" data-id="element-182">
              $0.005 - $0.02
            </div>
            <div className="text-gray-500 text-sm mb-4" data-id="element-183">
              per additional message
              <span className="block text-xs italic mt-1" data-id="element-184">
                Adjustable by country
              </span>
            </div>
            <ul className="text-gray-600 space-y-2" data-id="element-185">
              <li className="flex items-start" data-id="element-186">
                <svg className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-187">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-188" />
                </svg>
                <span data-id="element-189">Flexible usage</span>
              </li>
              <li className="flex items-start" data-id="element-190">
                <svg className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-191">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-192" />
                </svg>
                <span data-id="element-193">Enhanced capabilities</span>
              </li>
              <li className="flex items-start" data-id="element-194">
                <svg className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-195">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-196" />
                </svg>
                <span data-id="element-197">Pay only for what you use</span>
              </li>
            </ul>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-198">
            <div className="bg-[#e5f8f7] p-3 rounded-full inline-block mb-4" data-id="element-199">
              <CalendarIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-200" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-201">Subscription</h3>
            <p className="text-gray-600 mb-4" data-id="element-202">
              Monthly unlimited AI access bundled with existing telecom plans.
            </p>
            <div className="text-[#54d4cb] font-bold text-2xl mb-2" data-id="element-203">
              $4.99 - $9.99
            </div>
            <div className="text-gray-500 text-sm mb-4" data-id="element-204">
              per month
              <span className="block text-xs italic mt-1" data-id="element-205">
                Adjustable by country
              </span>
            </div>
            <ul className="text-gray-600 space-y-2" data-id="element-206">
              <li className="flex items-start" data-id="element-207">
                <svg className="h-5 w-5 text-[#54d4cb] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-208">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-209" />
                </svg>
                <span data-id="element-210">Unlimited usage</span>
              </li>
              <li className="flex items-start" data-id="element-211">
                <svg className="h-5 w-5 text-[#54d4cb] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-212">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-213" />
                </svg>
                <span data-id="element-214">Premium AI capabilities</span>
              </li>
              <li className="flex items-start" data-id="element-215">
                <svg className="h-5 w-5 text-[#54d4cb] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-216">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-217" />
                </svg>
                <span data-id="element-218">Priority response times</span>
              </li>
              <li className="flex items-start" data-id="element-219">
                <svg className="h-5 w-5 text-[#54d4cb] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-220">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-221" />
                </svg>
                <span data-id="element-222">Ad-free experience</span>
              </li>
            </ul>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-223">
            <div className="bg-purple-100 p-3 rounded-full inline-block mb-4" data-id="element-224">
              <DollarSignIcon className="h-8 w-8 text-purple-600" data-id="element-225" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-226">Sponsored Content</h3>
            <p className="text-gray-600 mb-4" data-id="element-227">
              Revenue from local business recommendations and sponsored content.
            </p>
            <div className="text-purple-600 font-bold text-2xl mb-2" data-id="element-228">
              Variable
            </div>
            <div className="text-gray-500 text-sm mb-4" data-id="element-229">
              based on partnerships
              <span className="block text-xs italic mt-1" data-id="element-230">
                Tailored to local markets
              </span>
            </div>
            <ul className="text-gray-600 space-y-2" data-id="element-231">
              <li className="flex items-start" data-id="element-232">
                <svg className="h-5 w-5 text-purple-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-233">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-234" />
                </svg>
                <span data-id="element-235">Local business partnerships</span>
              </li>
              <li className="flex items-start" data-id="element-236">
                <svg className="h-5 w-5 text-purple-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-237">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-238" />
                </svg>
                <span data-id="element-239">Relevant recommendations</span>
              </li>
              <li className="flex items-start" data-id="element-240">
                <svg className="h-5 w-5 text-purple-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-241">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-242" />
                </svg>
                <span data-id="element-243">Additional revenue stream</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-244">
          <h3 className="text-2xl font-bold mb-6" data-id="element-245">
            Ready to Join Us in Bringing AI to the Next Billion Users?
          </h3>
          <a href="https://calendly.com/es-lee/intro?referrer=voxiesite" target="_blank" rel="noopener noreferrer" className="bg-[#54d4cb] text-white px-8 py-4 rounded-md font-medium hover:bg-[#43aca5] transition-colors text-lg inline-block" data-id="element-246">
            Book A Time To Chat
          </a>
        </div>
      </div>
    </section>;
};
export default Monetization;